import { deleteCookie, getCookie, setCookie } from "~/common/utils/cookie";
import dayjs from "dayjs";

const REGION_COOKIE = "cache.region";

export function getRegionCookie(): string {
  return getCookie(REGION_COOKIE)?.value ?? "";
}

export function setRegionCookie(region: string) {
  setCookie({ name: REGION_COOKIE, value: region, expireDate: dayjs().add(1, "w").toDate() }); // expires in 1 week from NOW
}

export const deleteRegionCookie = () => {
  deleteCookie(REGION_COOKIE);
};
